import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDeviceType } from "@vfit/shared/hooks";
import { STORY_MODAL_NOTIFICATION_EVENT } from "./StoryModal.models";
import VfStoryModal from "./VfStoryModal/VfStoryModal";
import Story from "../../Story";
import { getStorySize } from "./StoryModal.utils";
export var StoryModalWrapper = function() {
    var initialStory = {
        onClose: function() {},
        stories: []
    };
    var deviceType = useDeviceType();
    var ref = useState(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = useState(initialStory), modalDetail = ref1[0], setModalDetail = ref1[1];
    var ref2 = useState({
        width: 405,
        height: 720
    }), storySize = ref2[0], setStorySize = ref2[1];
    var onStoryModalNotificationEvent = function(event) {
        var detail = event.detail;
        setModalDetail(detail || modalDetail);
        setShowModal(!showModal);
    };
    useEffect(function() {
        setStorySize(getStorySize(deviceType.isMobile, deviceType.isTablet));
    }, [
        deviceType
    ]);
    useEffect(function() {
        if (typeof document !== "undefined") {
            document.addEventListener(STORY_MODAL_NOTIFICATION_EVENT, onStoryModalNotificationEvent);
        }
        return function() {
            return document.removeEventListener(STORY_MODAL_NOTIFICATION_EVENT, onStoryModalNotificationEvent);
        };
    }, []);
    var resetModalStatus = function() {
        setModalDetail(initialStory);
        setShowModal(false);
    };
    var handleCloseModal = function() {
        if (modalDetail.onClose) modalDetail.onClose();
        resetModalStatus();
    };
    return /*#__PURE__*/ _jsx(VfStoryModal, {
        isOpen: showModal,
        handleClose: handleCloseModal,
        children: /*#__PURE__*/ _jsx(Story, {
            loop: true,
            keyboardNavigation: true,
            defaultInterval: 8000,
            stories: modalDetail.stories,
            onStoryEnd: function(s, st) {
                return console.log("story ended", s, st);
            },
            onAllStoriesEnd: function(s, st) {
                return console.log("all stories ended", s, st);
            },
            onStoryStart: function(s, st) {
                return console.log("story started", s, st);
            },
            onNext: function() {
                return console.log("next button pressed");
            },
            onPrevious: function() {
                return console.log("previous button pressed");
            },
            storyContainerStyles: {
                borderRadius: "20px",
                overflow: "hidden",
                margin: "0 auto",
                position: "absolute",
                top: "50%",
                right: "50%",
                transform: "translate(50%,-50%)",
                backgroundColor: "red"
            },
            width: storySize.width,
            height: storySize.height
        })
    });
};
